/* eslint-disable import/prefer-default-export */
export { default as CmsComponentSwitch } from './CmsComponentSwitch';
